import { Component, OnInit } from "@angular/core";
import { IClientStatistics } from "src/app/models/client/client-statistics";
import { ClientService } from "src/app/services/client.service";

@Component({
  selector: "app-usage-summary",
  templateUrl: "./usage-summary.component.html",
  styleUrls: ["./usage-summary.component.scss"],
})
export class UsageSummaryComponent implements OnInit {
  stats: IClientStatistics | null = null;
  isLoading = true;

  constructor(private readonly _clientService: ClientService) {}

  ngOnInit() {
    this._clientService.getStatistics().subscribe(stats => {
      this.stats = stats;
      this.isLoading = false;
    });
  }
}
